import currencies from '../../../assets/json/currencies.json';
import { CurrencyFormat } from '../InputCurrency.vue.d';

const getCurrency = (code?: string): CurrencyFormat => {
  let currCode = code ?? 'IDR';

  /*
   * When the code is given, it should not find the user currency settings
   * Argument 'code' has higher priority than default currency settings
   */
  if (!code) {
    const { generalSetting = {} } = JSON.parse(
      localStorage.getItem('user') ?? '{}',
    );

    if (generalSetting.currency) currCode = generalSetting.currency.currency;
  }

  return (
    currencies.find((curr) => curr.currency === currCode) ?? {
      label: '$ - United States Dollar',
      name: 'United States Dollar',
      currency: 'USD',
      symbol: '$',
      locale: 'en-US',
    }
  );
};

const formatCurrency = (
  value?: number | string | null,
  currency?: string,
  prefix = true,
): string => {
  const { locale, currency: code } = getCurrency(currency);

  if (value == null) return '-';

  return Number(value)
    .toLocaleString(locale, {
      style: prefix ? 'currency' : undefined,
      currency: code,
    })
    .replace('Rp ', 'Rp'); // Remove U+00a0 (Non-Breaking space character) after 'Rp'
};

export { formatCurrency, getCurrency };
